import React from 'react';
import { Outlet } from 'react-router-dom';
import ExtraMileHeader from '../ExtraMileHeader/ExtraMileHeader';
import { ASSET } from '../../utils/sopGame';
import './AppShell.css';

export default function AppShell() {
  return (
    <div
      className="ddd-user-shell sop-shell-bg"
      style={{ backgroundImage: `url(${ASSET.img('bg.png')})` }}
    >
      <ExtraMileHeader />
      <div className="ddd-user-main">
        <Outlet />
      </div>
    </div>
  );
}
